var _mask, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBetaPanel = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 432,
    height: 112.052,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 432 112.052",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "svg_0b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.47 111.408c-.792.858-2.148.858-2.94 0l-7.56-8.191a10 10 0 0 0-7.348-3.217H10c-5.5228 0-10-4.4772-10-10V10C0 4.4772 4.4772 0 10 0h412c5.523 0 10 4.4772 10 10v80c0 5.5228-4.477 10-10 10h-13.622a10 10 0 0 0-7.348 3.217z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5F3FF",
    d: "M393.47 111.408c-.792.858-2.148.858-2.94 0l-7.56-8.191a10 10 0 0 0-7.348-3.217H10c-5.5228 0-10-4.4772-10-10V10C0 4.4772 4.4772 0 10 0h412c5.523 0 10 4.4772 10 10v80c0 5.5228-4.477 10-10 10h-13.622a10 10 0 0 0-7.348 3.217z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_1a)",
    d: "m393.47 111.408.734.679.001-.001zm-2.94 0-.735.678.001.001zM0 90h-1zm0-80h-1zm432 0h1zm0 80h1zm-30.97 13.217.735.679zm-18.06 0-.735.679zm10.5 8.191-.735-.678c-.396.429-1.074.429-1.47 0l-.735.678-.734.679c1.187 1.286 3.221 1.286 4.408 0zm-2.94 0 .735-.678-7.56-8.191-.735.678-.735.679 7.56 8.19zM375.622 100v-1H10v2h365.622zM10 100v-1c-4.9706 0-9-4.0294-9-9h-2c0 6.0751 4.9249 11 11 11zM0 90h1V10h-2v80zm0-80h1c0-4.9706 4.0294-9 9-9v-2C3.9249-1-1 3.9249-1 10zM10 0v1h412v-2H10zm412 0v1c4.971 0 9 4.0294 9 9h2c0-6.0751-4.925-11-11-11zm10 10h-1v80h2V10zm0 80h-1c0 4.9706-4.029 9-9 9v2c6.075 0 11-4.9249 11-11zm-10 10v-1h-13.622v2H422zm-20.97 3.217-.735-.678-7.56 8.191.735.678.735.678 7.56-8.19zm7.348-3.217v-1c-3.07 0-6 1.283-8.083 3.539l.735.678.735.679a9 9 0 0 1 6.613-2.896zm-25.408 3.217.735-.678A11.001 11.001 0 0 0 375.622 99v2c2.512 0 4.909 1.05 6.613 2.896z",
    mask: "url(#svg_0b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_1a",
    x1: 0,
    x2: 274.769,
    y1: 0,
    y2: 210.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0072FF"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBetaPanel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/beta-panel.e15e0d42ca868a06be3bed46e47d977d.svg";